<!--
주문하기 > 상품 리스트
------------------------------------
-->
<template>
    <app-layout-group
        icon="shopping_cart"
        :header="'주문상품('+jobTargets.length+')'"
    >

        <div slot="button">
            <button
                class="uk-button uk-button-white"
                title="모든 주문상품의 구입단가를 할인(%)이 적용된 가격으로 계산합니다"
                @click="displayCalc = ! displayCalc"
            >
                <i class="material-icons">edit</i>
                일괄 할인(%) 적용
            </button>
        </div>

        <div slot="body" class="app-table-normal">
            <!-- 일괄계산 -->
            <div v-show="displayCalc" class="uk-text-center uk-margin-bottom">
                <div class="">
                    모든 상품의 단가를 기준으로 할인율을 적용하여 <b>구입단가</b>를 계산합니다<br />
                    * 소수점 2자리 반올림 처리합니다
                </div>
                <div class="uk-text-muted uk-margin-small-bottom">
                    e.g. 단가(100) X 할인율(10%) = 구입단가(90)
                </div>
                <div class="dc-form uk-flex uk-flex-center uk-flex-middle">
                    <div class="title">
                        할인율
                    </div>

                    <div>
                        <app-input-text
                            class="rate"
                            v-model="inputDcRate"
                            input-size="small"
                        >
                        </app-input-text>
                    </div>

                    <div class="unit">
                        %
                    </div>

                    <div>

                        <button
                            class="uk-button uk-button-small uk-button-primary"
                            @click="calcPrice"
                        >
                            <i class="material-icons">done</i>
                            적용하기
                        </button>


                        <button
                            class="uk-button uk-button-small uk-button-default"
                            @click="displayCalc = false"
                        >
                            <i class="material-icons">cancel</i>
                            취소
                        </button>


                    </div>
                </div>


            </div>


            <!-- 리스트 -->
            <table class="uk-table uk-table-small uk-table-middle app-prod-table">
                <colgroup>

                    <col class="col-prod-id">
                    <col style="width: 10rem">


                    <col class="col-amount">
                    <col class="col-options">

                    <col style="width: 10rem">
                    <col style="width: 10rem">
                    <col style="width: 10rem">

                    <col>

                    <col style="width: 10rem">


                    <col style="width: 10rem">
                    <col class="col-state">

                    <col style="width: 6rem">
                </colgroup>

                <thead>
                <tr>

                    <th scope="col" class="uk-text-center">
                        상품번호
                    </th>
                    <th scope="col" class="uk-text-center">
                        해외상품코드
                    </th>


                    <th scope="col" class="uk-text-center">
                        수량
                    </th>
                    <th scope="col" class="uk-text-center">
                        옵션
                    </th>

                    <th scope="col" class="uk-text-center">
                        판매단가(KRW)
                    </th>
                    <th scope="col" class="uk-text-center">
                        단가<br />
                        (업체 참고용 단가)
                    </th>
                    <th scope="col" class="uk-text-center">
                        구입단가<br />
                        (통관시 사용)


                    </th>


                    <th scope="col" class="uk-table-expand">
                        브랜드명/상품명/판매단가
                    </th>


                    <th scope="col" class="uk-text-center">
                        마켓
                    </th>


                    <th scope="col" class="uk-text-center">
                        수취인
                    </th>
                    <th scope="col" class="uk-text-center">
                        배송단계
                    </th>

                    <th scope="col" class="uk-text-center">
                        제거
                    </th>
                </tr>
                </thead>
                <tbody>


                <tr v-for="target in jobTargets" :key="target.prod.id">

                    <td class="uk-text-center">
                        <div class="id" title="상품번호">
                            {{ target.prod.id }}
                        </div>
                        <div class="detail">
                            <a
                                class="uk-link-reset uk-button uk-button-white uk-button-small"
                                :href="'/prods/'+target.prod.id"
                                target="_blank"
                                title="상품 상세페이지"
                            >
                                <i class="material-icons">link</i>
                                상품
                            </a>
                        </div>
                    </td>
                    <td class="uk-text-center">
                        {{ target.prod.vender_code }}
                    </td>



                    <td class="uk-text-center">
                        <span class="" v-show="target.prod.amount < 2">{{ target.prod.amount }}</span>
                        <span class="uk-text-large uk-text-primary" v-show="target.prod.amount >= 2">{{ target.prod.amount }}</span>

                    </td>
                    <td class="uk-text-center">
                        <div class="color uk-margin-bottom" title="색상">{{ target.prod.color }}</div>
                        <div class="size" title="사이즈">{{ target.prod.size }}</div>
                    </td>

                    <td class="uk-text-center">
                        <input-price
                            currency="KRW"
                            v-model="target.inputHpOrderUnitPriceKrw"
                        ></input-price>

                    </td>
                    <td class="uk-text-center">
                        <input-price
                            :currency="target.prod.unit_price_currency"
                            v-model="target.inputUnitPrice"
                        ></input-price>

                    </td>
                    <td class="uk-text-center">
                        <input-price
                            :currency="target.prod.buy_unit_price_currency"
                            v-model="target.inputBuyUnitPrice"
                        ></input-price>

                        <div v-show="dcRate > 0" class="uk-text-primary">
                            할인율: {{ dcRate }}%
                        </div>
                    </td>


                    <td>
                        <div class="uk-flex uk-flex-left uk-flex-wrap">
                            <div class="uk-margin-small-right img">
                                <a :href="target.prod.vender_url" target="_blank">
                                    <img
                                        :src="target.prod.img_url"
                                        :data-src="target.prod.img_url"
                                        class=" lazyloaded"
                                        style="object-fit: contain; width: 100px; height: 100px;"
                                    />
                                </a>
                            </div>
                            <div>
                                <span class="brand" title="브랜드">{{ target.prod.brand }}</span>
                                <div class="name" title="상품명">
                                    <a class="uk-link-reset" :href="target.prod.vender_url" target="_blank">
                                        {{ target.prod.name }}
                                    </a>
                                </div>
                                <div class="hp_order_unit_price_krw uk-margin-top" title="마켓 판매단가" v-show="target.prod.hp_order_unit_price_krw_text">
                                    {{ target.prod.hp_order_unit_price_krw_text }}
                                </div>
                            </div>
                        </div>
                    </td>


                    <td class="">
                        <div class="hp_order_market" title="마켓명">
                            {{ target.prod.hp_order_market }}
                        </div>
                        <div class="hp_order_seller" title="셀러ID">{{ target.prod.hp_order_seller }}</div>

                        <div class="hp_order_name" title="주문자">{{ target.prod.hp_order_name }}</div>
                        <div class="hp_order_id" title="주문ID">{{ target.prod.hp_order_id }}</div>
                        <div class="hp_order_at" title="주문일">{{ target.prod.hp_order_at }}</div>
                    </td>


                    <td class="uk-text-center">
                        <div class="uk-margin-small-bottom" title="배송코드">{{ target.prod.house_code }}</div>

                        <div title="수취인">{{ target.prod.h_name }}</div>
                    </td>
                    <td class="uk-text-center">
                        <div class="state" title="배송단계">{{ target.prod.state_text }}</div>
                    </td>

                    <td class="uk-text-center">
                        <button
                            type="button"
                            class="uk-button uk-button-small uk-button-gray"
                            title="현재 주문에서 이 상품을 제외합니다"
                            @click="removeTarget(target.prod.id)"
                        >
                            취소
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

            <!-- 총 합계 표시-->
            <div class="total-buy-price">
                총 구매금액 ({{ regionCurrency }}) :
                <strong v-comma-number="totalBuyPrice">
                </strong>
            </div>
        </div>
    </app-layout-group>
</template>

<script>
    export default {
        components: {
            'input-price': require('./input-price.vue').default,
        },
        props: {
            /**
             * 작업대상 배열
             */
            jobTargets: {
                type: Array,
                default: [],
            },

            // 지역화폐
            regionCurrency: String,

            // 총 구매금액
            totalBuyPrice: {
                type: Number,
                default: 0,
            },
        },
        data: function () {
            
            return {
                // 구입단가 계산 폼 display 여부
                displayCalc: false,

                // 적용된 할인율(%)
                dcRate: 0,

                // 할인율(%) 입력값
                inputDcRate: 0,
            };
        },
        computed: {
        },
        methods: {

            /**
             * 상품을 작업대상에서 제거
             * @param prod_id (int) 상품번호
             */
            removeTarget(prod_id) {
                if (! confirm('현재 주문에서 이 상품을 제거합니까?')) {
                    return;
                }
                this.jobTargets.splice(_.findIndex(this.jobTargets, (target) => {
                    return target.prod.id === prod_id;
                }), 1);
            },

            /**
             * 구입단가 할인율 적용 계산
             */
            calcPrice() {
                if (isNaN(this.inputDcRate)) {
                    alert('숫자를 입력하세요');
                    return;
                }

                let rate = parseFloat(this.inputDcRate);


                // 각 상품 계산
                _.each(this.jobTargets, (target) => {
                    let price = parseFloat(target.inputUnitPrice);
                    let dc = price * rate / 100;
                    target.inputBuyUnitPrice = _.round(price - dc, 2);
                });

                // 할인율 적용된걸로 저장
                this.dcRate = rate;

                // 폼 닫기
                this.displayCalc = false;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .total-buy-price {
        text-align: center;
        font-size: 1rem;
        color: #000;

        strong {
            font-size: 1.5rem;
            color: #1e87f0;
            font-weight: bold;
        }
    }

    .dc-form {
        .title {
            margin-right: 0.5rem;
        }

        .rate {
            width: 6rem;
        }

        .unit {
            font-size: 1.5rem;
            color: #999;
        }
    }
</style>